module.exports = __webpack_public_path__ + "img/hr-tree-06-h-leaves.e499517e.png";